import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { SystemNotificationsService } from "../../../services/system-notifications.service";
import { SystemNotification } from "../../../models/system-notifications/system-notification";
import { UserInfoService } from "../../../services/user-info.service";
import { TopBannerShellComponent } from "../../../shared/components/top-banner/top-banner-shell.component";
import { TopBannerRowComponent } from "../../../shared/components/top-banner/top-banner-row.component";

@Component({
  selector: "app-system-notifications",
  standalone: true,
  templateUrl: "./system-notifications.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TopBannerShellComponent, TopBannerRowComponent],
})
export class SystemNotificationsComponent implements OnInit {
  private mode: "before" | "after" = "before";
  messages: SystemNotification[] = [];

  constructor(
    private sysNotifService: SystemNotificationsService,
    private userInfoService: UserInfoService,
  ) {}

  async ngOnInit() {
    const hasSessionContext = !!this.userInfoService.getSessionContext?.();
    this.mode = hasSessionContext ? "after" : "before";

    this.messages =
      this.mode === "before"
        ? await this.sysNotifService.getFetchedAndFilteredNotificationsBeforeLogin()
        : await this.sysNotifService.getFetchedAndFilteredNotificationsAfterLogin();
  }

  async onClose(message: SystemNotification) {
    const index = this.messages.indexOf(message);
    if (index === -1) {
      return;
    }

    if (this.mode === "after") {
      await this.sysNotifService.markNotificationAsRead(message);
    }

    this.sysNotifService.markSystemNotificationAsReadInSession(message.id);
    this.messages.splice(index, 1);
  }
}
